'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { MODAL_BACKGROUND_TRANSITION_TIMING, DEFAULT_MODAL_TRANSITION_TIMING } from 'HubStyleTokens/times';
import TwoWayTransition from '../../transitions/TwoWayTransition';
import { ModalTransitionContextProvider } from '../../context/ModalTransitionContext';
import { getOverlayTransition } from './overlayTransitionMixin';
import UIDialog from '../UIDialog';
const totalTransitionTime = parseInt(DEFAULT_MODAL_TRANSITION_TIMING, 10);
const overlayTransitionTime = parseInt(MODAL_BACKGROUND_TRANSITION_TIMING, 10);
const dialogTransitionTime = totalTransitionTime - overlayTransitionTime;
const overlayTransition = getOverlayTransition(dialogTransitionTime);
const ModalTransitionWrapper = styled(TwoWayTransition.PlainWrapper).withConfig({
  displayName: "ModalTransition__ModalTransitionWrapper",
  componentId: "sc-15ztnrv-0"
})(["", "{transition-property:", ";transition-delay:", "ms;transition-duration:", "ms;opacity:", ";transform:", ";}", ";"], UIDialog.Selector, ({
  transitionActive
}) => transitionActive ? 'opacity, transform' : 'none', overlayTransitionTime, dialogTransitionTime, ({
  open
}) => open ? '1' : '0', ({
  open
}) => `scale(${open ? '1' : '0.9'})`, overlayTransition);

const ModalTransition = props => /*#__PURE__*/_jsx(TwoWayTransition, Object.assign({}, props, {
  ContextProvider: ModalTransitionContextProvider,
  duration: totalTransitionTime,
  transitionOnMount: true,
  Wrapper: ModalTransitionWrapper
}));

ModalTransition.displayName = 'ModalTransition';
export default ModalTransition;